import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleMap from "../../components/Common/Map/simpleMap";
import CommonSelect from "../../components/Common/Select";
import { useDispatch, useSelector } from "react-redux";
import { fetchRoles } from "../../store/actions";
import { createSelector } from "reselect";
import Select from "react-select";
import { postLogin } from "../../helpers/backend_helper";
import { formatDateToYYYYMMDD } from "../../helpers/formatDate";
import ErrorAlert from "../../components/Common/Error/ErrorAlert";

import { fetchBeats, fetchDivisions, fetchRanges, fetchRounds, getAllUSer } from '../../store/actions';
import { checkFilterMatch } from "../../helpers/general";

export default function TrackLocation() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [locations, setLocations] = useState([]);
  const [assignedUser, setAssignedUser] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filteredUserss, setFilteredUserss] = useState([]);

  const [users, setUsers] = useState([]);
  const [message,setMessage]=useState("")
  const [selectedRole, setSelectedRole] = useState(null);
 const [formData, setFormData] = useState({
    division: '',
    range: '',
    round: '',
    beat: ''
  });
  const commonSelector = createSelector(
    (state) => state.Common,
    (Common) => ({
      roles: Common.roles || [],
    })
  );

  // const { roles,divisions, ranges, rounds, beats, error  } = useSelector(commonSelector);

   const { roles, divisions, ranges, allUsersnvehicle,rounds, beats, error } = useSelector(
      (state) => state.Common || {}
    );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRoles());
    setUsers(allUsersnvehicle);
  }, [dispatch]);

  // Load initial dropdown data only once when component mounts
    useEffect(() => {
          dispatch(getAllUSer());
      
      dispatch(fetchDivisions());
      // Only try to load initial data if we have form values on first render
      const { division, range, round, beat } = formData;
      if (division) {
        dispatch(fetchRanges(division));
        
        if (range) {
          dispatch(fetchRounds(range));
          
          if (round) {
            dispatch(fetchBeats(round));
          }
        }
      }
    }, []); // Empty dependency array means this runs only once on mount
  
  useEffect(() => {
    if (selectedRole) {
      const usersByRole = allUsersnvehicle?.filter((user) => {
        const userRoles = user["regionId#roleId#userId"].split("#");
        return userRoles[1] == selectedRole.value.toString(); // Compare roleId
      });
      setFilteredUsers(usersByRole);
      setFilteredUserss(usersByRole);

    } else {
      setFilteredUsers(users);
      setFilteredUserss(users);

    }
  }, [selectedRole, users]);


  console.log('filteredUsers',filteredUsers)
  const handleFetchLocations = async () => {
    if (!assignedUser) {
      setMessage("Please select a User/Vehicle");
      return;
    }
    const formattedDate = formatDateToYYYYMMDD(selectedDate);
    try {
      const payload = {
        act: "user",
        subact: "getUserLocation",
        info: {
          userId: assignedUser.id,
          date: formattedDate,
        },
      };
      const response = await postLogin(payload);
      if (response?.message) {
        setLocations(response?.data || []);
      }
      if(response?.data?.length===0){
        setMessage("No record founds")

      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };
  const dependentDropdowns = [
      {
        label: "Division",
        key: "division",
        data: divisions,
        fetch: fetchRanges,
      },
      {
        label: "Range",
        key: "range",
        data: ranges,
        fetch: fetchRounds,
      },
      {
        label: "Round",
        key: "round",
        data: rounds,
        fetch: fetchBeats,
      },
      {
        label: "Beat",
        key: "beat",
        data: beats,
        fetch: null,
      },
    ];
// Handle input changes with optional cascading fetches
const handleInputChange = (e, key, fetchAction = null) => {
  setMessage("")
  e.preventDefault();
  setAssignedUser(null); // Reset selected user when role changes
  setLocations([]); // Reset locations when form data changes
 ; // Reset message when form data changes
  const value = e.target.value;

  setFormData((prev) => {
    const updatedData = { ...prev, [key]: value };
    if (value === "0") {
      const keyIndex = dependentDropdowns.findIndex((dropdown) => dropdown.key === key);
      if (keyIndex !== -1) {
        for (let i = keyIndex + 1; i < dependentDropdowns.length; i++) {
          updatedData[dependentDropdowns[i].key] = undefined; // Reset the dependent dropdowns
        }
      }
    } else if (fetchAction) {
      dispatch(fetchAction(Number(value)));
    }

    return updatedData;
  });
};

 useEffect(() => {
  if (!filteredUserss?.length) return;

  const result = filteredUserss.filter((user) => {
    if (!checkFilterMatch(formData.division, user.divisionId)) return false;

    // Range filter  
    if (!checkFilterMatch(formData.range, user.rangeId)) return false;

    // Round filter
    if (!checkFilterMatch(formData.round, user.roundId)) return false;

    // Beat filter
    if (!checkFilterMatch(formData.beat, user.beatId)) return false;

    return true; // Include user if all filters pass
  });

  setFilteredUsers(result);
}, [formData.division, formData.range, formData.round, formData.beat, filteredUserss]);


  const filterRole = roles.filter(
    (role) => role.role == "Vehicle" || role.role === "Forest Guard" || role.role === "Beat Guard"
  );

  const handeAssignedUser = (selectedOption) => {
    setAssignedUser({
      id: selectedOption?.value,
      name: selectedOption?.label,
    });
    setMessage("") // Reset message when user changes
    setLocations([]); // Reset locations when user changes
  }
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Control Room" breadcrumbItem="Track Locations" />

        <Row>
          <Col md="3">
            <Form>
              {/* Guard Selection */}
              <FormGroup>
                <Label for="guardSelect">Select Role</Label>
                <div className="mb-3">
                  <Select
                    options={filterRole?.map((role) => ({
                      value: role.roleId,
                      label: role.role,
                    }))}
                    onChange={(selectedOption) => {
                      setSelectedRole(selectedOption);
                      setAssignedUser(null); // Reset selected user when role changes
                    }}
                    placeholder="Select role..."
                    isClearable
                  />
                </div>
                <Row>
            {dependentDropdowns.map(
              ({ label, key, data, fetch }, index) => (
                <Col md={6} key={key}>
                  <FormGroup>
                    <Label for={key}>{label}</Label>
                    <Input
                      type="select"
                      id={key}
                      value={formData[key] || ""}
                      onChange={(e) => handleInputChange(e, key, fetch)}
                      disabled={
                       
                        (index > 0 &&
                          !formData[
                            ["division", "range", "round"][index - 1]
                          ]) ||
                          (index > 0 && formData["division"] === "0")
                      }
                    >
                      <option value="0">All</option>
                      {Array.isArray(data?.data) &&
                        data.data.map((item) => (
                          <option
                            key={item[`${key}Id`]}
                            value={item[`${key}Id`]}
                          >
                            {item.name || item.divisionName || item.rangeName || item.beatName|| item.roundName}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </Col>
              )
            )}
          </Row>
                <div className="mb-3">
                  <label className="form-label">Select User</label>
                  <Select
                     options={filteredUsers?.map((user) => {
                      const roleId = user['regionId#roleId#userId']?.split("#")[1]; // Extract roleId
                      return {
                        value: user.userId,
                        label:
                          roleId === "6"
                            ? `${user.firstName} ${user.lastName} (${user.email})`
                            : `${user.firstName} ${user.lastName}`,
                      };
                    })}
                    role={selectedRole?.value}
                    onChange={(selectedOption) =>{handeAssignedUser(selectedOption)}}
                    placeholder="Search and select user..."
                    isClearable
                    isDisabled={!selectedRole}
                    value={assignedUser ? { value: assignedUser.id, label: assignedUser.name } : null}
                  />
                </div>
              </FormGroup>

              {/* Date Picker */}
              <FormGroup>
                <Label>Select Date</Label>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  onChangeRaw={(e) => e.preventDefault()} 
                />
              </FormGroup>

              {/* Fetch Button */}
              <Button color="primary" block onClick={handleFetchLocations}>
                Go
              </Button>
            </Form>
            
            {message.length>0 && <div className="mt-3"><ErrorAlert error={message} />  </div>}
          
          </Col>

          {/* Map Display */}
          <Col md="9">
            <div
              style={{
                height: "70vh",
                marginTop: "20px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <SimpleMap locations={locations} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
